export function initWebComponent(element, template, shadowRoot = false) {
    // No shadow
    if(shadowRoot) {
        element.attachShadow({ mode: 'open'});
        element.shadowRoot.appendChild(template.content.cloneNode(true));
    }
    element.innerHTML = template.innerHTML
}
